// 3512QueryYB.js - 医保商品追溯信息查询信息查询接口 (3512)
import { ybRequestTemplate } from "/src/untils/ybRequestTemplate.js"
import { addYbRquestData, getqdNo } from "@/api/yb";
import axios from "axios";
import dayjs from "dayjs";
/**
 * 医保商品追溯信息查询信息查询接口 (3512)
 * @param {Object} row - 要查询的行数据
 * @param {Object} userData - 用户信息
 * @param {Object} clinicInfo - 诊所信息
 * @param {String} startTime - 开始时间
 * @param {String} endTime - 结束时间
 * @param {Function} addStepMessage - 添加步骤消息的函数
 * @param {Function} addOperationStepMessage - 添加操作步骤消息的函数
 * @param {Function} updateOperationProgress - 更新进度条的函数
 * @param {Function} updateOperationStepStatus - 更新步骤状态的函数
 * @returns {Promise} 查询结果
 */
export const queryMedicalInsuranceStorage3512 = async (
  row, 
  userData, 
  clinicInfo, 
  startTime,  // 新增：开始时间参数
  endTime,    // 新增：结束时间参数
  addStepMessage, 
  addOperationStepMessage, 
  updateOperationProgress,
  updateOperationStepStatus
) => {
  try {
    addStepMessage('开始执行医保商品追溯信息查询信息查询流程(3512)...');
    
    // 准备查询请求数据
    addOperationStepMessage('准备查询请求数据...');
    const ybRequest = JSON.parse(JSON.stringify(ybRequestTemplate));
    const today = dayjs().format('YYYY-MM-DD');
    
    // 获取签到编号
    const signNoRes = await getqdNo();
    let signNo = '';
    if (signNoRes.code === 200) {
      signNo = signNoRes.data.signNo;
      addStepMessage(`签到业务ID: ${signNo}`);
    } else {
      throw new Error('获取签到流水号失败');
    }
    
    // 设置请求参数 - 3512接口
    ybRequest.body.infno = '3512';
    ybRequest.body.msgid = `${userData.clinicCode || '000000'}${dayjs().format('YYYYMMDDHHmmss')}${getRandom4Digits()}`;
    ybRequest.body.insuplc_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.mdtrtarea_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_sys_code = '007';
    ybRequest.body.infver = 'V1.049';
    ybRequest.body.opter_type = '1';
    ybRequest.body.opter = userData.userId || '1';
    ybRequest.body.opter_name = userData.staffName || '系统操作员';
    ybRequest.body.inf_time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    ybRequest.body.fixmedins_code = userData.clinicCode || '';
    ybRequest.body.fixmedins_name = userData.clinicName || '';
    ybRequest.body.sign_no = signNo;
    
    // 格式化时间参数
    const formattedStartTime = startTime ? dayjs(startTime).format('YYYY-MM-DD') : '';
    const formattedEndTime = endTime ? dayjs(endTime).format('YYYY-MM-DD') : '';
    
    // 设置查询数据 - 根据3512接口规范
    ybRequest.body.input.data = {
		fixmedins_code: row.medListCodg || '', // 定点医药机构编号
		medins_list_codg: row.medListCodg || '', // 定点医药机构医疗目录编码
		fixmedins_bchno: row.bchno || '', // 使用行数据中的定点医药机构批次流水号
		begndate: formattedStartTime, // 使用传入的开始时间
		enddate: formattedEndTime,    // 使用传入的结束时间

		med_list_codg: '' ,// 医疗目录编码
		drug_trac_codg:'84176725733439158107', // 药品追溯码
		mdtrtarea_admdvs:'530681', // 就医地区医保区划
    };
    
    addStepMessage(`查询时间范围: ${formattedStartTime} 至 ${formattedEndTime}`);
    addStepMessage('准备调用接口查询商品追溯信息查询信息(3512)...');
    
    // 先传给系统
    const newItem = {
      infno: 3512,
      mdtrtareaAdmvs: userData.mdtrtareaAdmvs || '',
      data: JSON.stringify(ybRequest.body),
      patientId: userData.staffId || '',
      patientName: userData.staffName || '系统操作员'
    };
    
    const res = await addYbRquestData(newItem);
    
    if (res.code !== 200) {
      throw new Error('医保查询数据准备失败: ' + res.message);
    }
    
    addStepMessage('医保查询数据准备完成，开始调用接口(3512)...');
    
    let responseData = res.data;
    if (typeof responseData === 'string') {
      try {
        responseData = JSON.parse(responseData);
      } catch (parseError) {
        throw new Error('解析医保响应数据失败');
      }
    }
    
    // 设置请求头
    ybRequest.headers.infosyscode = responseData.infosyscode || '';
    ybRequest.headers.hsf_signature = responseData.signature || '';
    ybRequest.headers.fixmedins_code = userData.clinicCode || '';
    ybRequest.headers.hsf_nonce = responseData.hsfNonce || '';
    ybRequest.headers.hsf_timestamp = responseData.hsfTimestamp || '';
    
    addStepMessage('调用医保商品追溯信息查询信息查询接口(3512)...');
    updateOperationProgress(70);
    updateOperationStepStatus(1, 'loading');
    
    // 调用医保接口
    const axiosConfig = {
      method: 'post',
      url: process.env.VUE_APP_BASE_YBHOST + `/eapdomain/callService`,
      baseURL: '',
      headers: ybRequest.headers,
      data: ybRequest.body,
    };
    
    const response = await axios(axiosConfig);
    const result = response.data || response;
    
    // 处理响应结果
    if (result.infcode === 0) {
      addStepMessage('医保商品追溯信息查询信息查询成功(3512)', { level: 'success' });
      updateOperationProgress(100);
      updateOperationStepStatus(1, 'success');
      
      // 处理查询结果数据
      if (result.output && result.output.data) {
        addStepMessage(`查询到 ${result.output.data.length} 条商品追溯信息查询信息`, { level: 'success' });
      }
      
      return result;
    } else {
      let errorMsg = '医保商品追溯信息查询信息查询失败(3512)';
      if (result) {
        errorMsg = result.err_msg || result.msg || result.message || '未知错误';
      }
      throw new Error(errorMsg);
    }
    
  } catch (error) {
    console.error('调用医保商品追溯信息查询信息查询接口(3512)异常:', error);
    updateOperationProgress(100);
    updateOperationStepStatus(1, 'error');
    throw error;
  }
};
/**
 * 生成4位随机数
 * @returns {string} 4位随机数字
 */
const getRandom4Digits = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};
// 添加辅助函数：判断是否为处方药
const getRxFlag = (row) => {
  const rxKeywords = ['抗生素', '麻醉', '精神', '处方', 'RX'];
  const drugName = row.fixmedinsHilistName || '';
  
  return rxKeywords.some(keyword => drugName.includes(keyword)) ? '1' : '0';
};